// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><!--! Font Awesome Pro 6.0.0-beta1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d=\"M320 368c-30.93 0-56 25.07-56 55.1s25.07 56 55.1 56S376 454.9 376 424S350.9 368 320 368z\"/></svg>";
// Exports
module.exports = code;